/**
 * Creates a conventional Promise that resolves after some number of
 * milliseconds.
 * @param duration - how many milliseconds to wait before resolving.
 * @returns - the promise has no value, it just resolves.
 */
export const timer = (duration: number) => {
    return new Promise( resolve => {
        setTimeout(resolve, duration);
    });
}

export default timer;
